const createBrowserHistory = require("history").createBrowserHistory

const _history = createBrowserHistory({})

export default () => {
    return _history
}


// WEBPACK FOOTER //
// ./src/store/getHistory.js